import { render, staticRenderFns } from "./ContestRedeemRoute.vue?vue&type=template&id=79a08e9b&scoped=true&"
import script from "./ContestRedeemRoute.vue?vue&type=script&lang=js&"
export * from "./ContestRedeemRoute.vue?vue&type=script&lang=js&"
import style0 from "./ContestRedeemRoute.vue?vue&type=style&index=0&id=79a08e9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a08e9b",
  null
  
)

export default component.exports